import zipObject from 'lodash/zipObject';

const ACTIONS = [
  /*
   * Auth
   * ==============================
   */

  'SEND_LOGIN_LINK',
  'SEND_LOGIN_LINK_SUCCESS',
  'SEND_LOGIN_LINK_FAILURE',

  'LOGIN',
  'LOGIN_SUCCESS',
  'LOGIN_FAILURE',

  'SAVE_ANONYMOUS_TOKEN',

  'LOGOUT',

  /*
   * Clients
   * ==============================
   */

  'CREATE_CLIENT',
  'CREATE_CLIENT_SUCCESS',
  'CREATE_CLIENT_FAILURE',

  'UPDATE_CLIENT',
  'UPDATE_CLIENT_SUCCESS',
  'UPDATE_CLIENT_FAILURE',

  'GET_CLIENTS',
  'GET_CLIENTS_SUCCESS',
  'GET_CLIENTS_FAILURE',

  'GET_CLIENT',
  'GET_CLIENT_SUCCESS',
  'GET_CLIENT_FAILURE',

  'GET_CLIENTS_STATS',
  'GET_CLIENTS_STATS_SUCCESS',
  'GET_CLIENTS_STATS_FAILURE',

  'CLEAR_CLIENTS_LIST',

  /*
   * Client CSV
   * ==============================
   */

  'UPLOAD_CLIENT_CSV',
  'UPLOAD_CLIENT_CSV_SUCCESS',
  'UPLOAD_CLIENT_CSV_FAILURE',

  'GET_CSV_UPLOAD_STATUS',
  'GET_CSV_UPLOAD_STATUS_SUCCESS',
  'GET_CSV_UPLOAD_STATUS_FAILURE',
  'CSV_OPERATION_COMPLETE',

  /*
   * Quotes
   * ==============================
   */

  'CREATE_QUOTE',
  'CREATE_QUOTE_SUCCESS',
  'CREATE_QUOTE_FAILURE',

  'UPDATE_QUOTE',
  'UPDATE_QUOTE_SUCCESS',
  'UPDATE_QUOTE_FAILURE',

  'GET_QUOTE',
  'GET_QUOTE_SUCCESS',
  'GET_QUOTE_FAILURE',

  'GET_QUOTES',
  'GET_QUOTES_SUCCESS',
  'GET_QUOTES_FAILURE',

  'HANDOFF_QUOTE',
  'HANDOFF_QUOTE_SUCCESS',
  'HANDOFF_QUOTE_FAILURE',

  'GET_PLANS',
  'GET_PLANS_SUCCESS',
  'GET_PLANS_FAILURE',

  'UPDATE_PLANS_FILTER',

  'CHECKOUT_QUOTE',
  'CHECKOUT_QUOTE_SUCCESS',
  'CHECKOUT_QUOTE_FAILURE',

  'FINALIZE_QUOTE',
  'FINALIZE_QUOTE_SUCCESS',
  'FINALIZE_QUOTE_FAILURE',

  /*
   * Policies
   * ==============================
   */

  'GET_POLICIES',
  'GET_POLICIES_SUCCESS',
  'GET_POLICIES_FAILURE',

  'GET_POLICY',
  'GET_POLICY_SUCCESS',
  'GET_POLICY_FAILURE',

  'SUBMIT_POLICY_NUMBER',
  'SUBMIT_POLICY_NUMBER_SUCCESS',
  'SUBMIT_POLICY_NUMBER_FAILURE',

  /*
   * Search
   * ==============================
   */

  'GET_SEARCH_RESULTS',
  'GET_SEARCH_RESULTS_SUCCESS',
  'GET_SEARCH_RESULTS_FAILURE',

  'CLEAR_SEARCH_RESULTS',

  /*
   * Broker
   * ==============================
   */

  'GET_BROKER',
  'GET_BROKER_SUCCESS',
  'GET_BROKER_FAILURE',

  'GET_BROKERAGE',
  'GET_BROKERAGE_SUCCESS',
  'GET_BROKERAGE_FAILURE',
];

const ACTION_TYPES = zipObject(ACTIONS, ACTIONS);
export default ACTION_TYPES;
